import React from 'react';
import * as S from './ErrorMmtScreenStyles';
import { HOB_BOOK_ANOTHER_CAB_CTA_CLICK } from '../../../../../utils/util-constants';
import { PROVISIONAL_HOB_OVERLAY_PAGE_LANDING, trackEvent } from '../../../../../config/omniMmt';

const ErrorMmtScreen = (props) => {
  const handleButtonClick = () => {
    trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_LANDING, HOB_BOOK_ANOTHER_CAB_CTA_CLICK)
    if (typeof window !== "undefined") {
      window.open(props?.cta?.mmtUrl, '_blank');
    }
  };

  return (
    <>
      <S.ErrorContainer>
        <S.ErrorImage src={props?.icon} />
        <S.ErrorTitle>{props?.title}</S.ErrorTitle>
        <S.ErrorMessage>{props?.message}</S.ErrorMessage>
      </S.ErrorContainer>
      <S.Container>
        <S.ButtonContainer onClick={handleButtonClick}>
          <S.ButtonTitle>{props?.cta?.text}</S.ButtonTitle>
        </S.ButtonContainer>
      </S.Container>
    </>
  );
};

export default ErrorMmtScreen; 